import { createContext } from 'react';
import type { TenantApiClient } from '../lib/tenant-api';

export const TenantScopeContext = createContext<TenantApiClient | undefined>(undefined);
